<div class="d-flex flex-column">
    Reservations on or before:
    <hr />
    <mat-form-field appearance="outline">
        <mat-label>Choose a date</mat-label>
        <input matInput [matDatepicker]="picker" [(ngModel)]="getFilterStateService().departureDate">
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker (opened)="datePickerOpened()" (closed)="datePickerClosed()"></mat-datepicker>
    </mat-form-field>
</div>